<div class="verify-email text-center">
  <h2 class="verify-title">Verify your email</h2>

  <p class="instructions">
    We sent a verification link to
    @if (email) {
      <strong class="user-email">{{ email }}</strong>
    } @else {
      your email address
    }. Please check your inbox (and spam folder), click the link, then come
    back here to continue.
  </p>

  <!-- Why they were sent here, when it was a refused write rather than sign-in. -->
  @if (reasonMessage) {
    <div class="server-error" role="alert">{{ reasonMessage }}</div>
  }

  @if (infoMessage) {
    <div class="success-message" role="status">{{ infoMessage }}</div>
  }

  @if (warningMessage) {
    <div class="server-error" role="alert">{{ warningMessage }}</div>
  }

  <div class="d-grid gap-2 mt-3">
    <button
      type="button"
      class="btn btn-primary btn-fill btn-danger"
      (click)="onContinue()"
      [disabled]="checking"
    >
      @if (checking) {
        Checking...
      } @else {
        I've verified, continue
      }
    </button>

    <button
      type="button"
      class="btn btn-primary btn-sm btn-fill"
      (click)="onResend()"
      [disabled]="resendCooldown > 0"
    >
      @if (resendCooldown > 0) {
        Resend available in {{ resendCooldown }}s
      } @else {
        Resend verification email
      }
    </button>

    <button type="button" class="btn btn-link signout-link" (click)="onSignOut()">
      Sign out
    </button>
  </div>
</div>
